import { useState, useEffect, useContext } from 'react'
import { Outlet } from "react-router-dom";
import { AuthContext } from '../../../AuthContext';

const SessionView = ({ username, onLogout }) => {
    return (
        <div>
            <p>Signed in as {username} </p>
            <input type="button"
                onClick={onLogout}
                value='Sign Out' />
        </div>
    )
}

const Navigation = () => {
    return (<nav id="root-nav">
        <ul>
            <li><a href={`/editor`}>dashboard</a></li>
            <li><a href={'/editor/artist_statement'}>artist statement</a></li>
            <li><a href={`/editor/portfolio`}>portfolio</a></li>
            <li><a href={`/editor/shop`}>shop</a></li>
            <li><a href={`/editor/contact`}>contact</a></li>
            <li><a href={`/editor/file_edit_demo`}>file edit demo</a></li>
            <li><a href={`/editor/doc_edit_demo`}>doc edit demo</a></li>
        </ul>
    </nav>)
}

export default function Editor() {

    const { authToken, claims, isLoading, onLogout } = useContext(AuthContext);

    return (
        <div id="root-layout">
            <header>
                {(authToken && isLoading === false) && <>
                    <SessionView
                        username={claims.sub}
                        onLogout={onLogout} />
                    <Navigation />
                </>}
            </header>
            <Outlet />
        </div>
    )
}